import { useContext, useEffect } from 'react';
import { AuthContext } from './contexts/AuthContext';
import { BrowserRouter, Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import Home from './pages/Home';
import SignInPage from './pages/SignInPage';
import AdminEditorSignInPage from './pages/AdminEditorSignInPage';
import StudentDashboardPage from './pages/StudentDashboardPage';
import StudentChat from './pages/StudentChat';
import StudentPaymentsPage from './pages/StudentPaymentsPage';
import StudentMyOrdersPage from './pages/StudentMyOrdersPage';
import MyWritersPage from './pages/MyWritersPage';
import PostNewOrderPage from './pages/PostNewOrderPage';
import StudentSettingsPage from './pages/StudentSettingsPage';
import PlaceOrder from './pages/PlaceOrderStep1';
import PlaceOrderStep2 from './pages/PlaceOrderStep2';
import PlaceOrderStep3 from './pages/PlaceOrderStep3';
import PlaceOrderStep4 from './pages/PlaceOrderStep4';
import Dashboard from './components/writer/Dashboard';
import BidOrders from './components/writer/BidOrders';
import WritersMyOrdersPage from './pages/WriterMyOrdersPage';
import WriterProfile from './pages/WriterProfile';
import WriterPayments from './pages/WriterPayment';
import WriterCreateAccountPage from './pages/WriterCreateAccountPage';
import WriterChat from './pages/WriterChat';
import EditorDashboardPage from './pages/EditorDashboard';
import EditorAssignedOrdersPage from './pages/EditorAssignedOrdersPage';
import EditorWritersPage from './pages/EditorWritersPage';
import EditorChatPage from './pages/EditorChatPage';
import AdminAllOrdersPage from './pages/AdminAllOrdersPage';
import AdminEditorsPage from './pages/AdminEditorsPage';
import AdminWritersPage from './pages/AdminWritersPage';
import AdminChatPage from './pages/AdminChatPage';
import OverDueTasksPage from './pages/OverdueTasksPage';
import StudentsPage from './pages/StudentsPage';
import AdminDashboardPage from './pages/AdminDashboard';
import FinancialReportsPage from './pages/FinancialReportsPage';
import AdminSettingsPage from './pages/AdminSettingsPage';
import WriterProfilePage from './pages/WriterProfilePage';
import EditorProfilePage from './pages/EditorProfilePage';
import NotFound from './components/NotFound';
import { Box, CircularProgress } from '@mui/material';
import ScrollToTop from './components/ScrollToTop';
import { PrivacyPolicy, RefundPolicy, TermsAndPrivacy,CookiePolicy } from './components/footerText';
import StudentMyFilesPage from './pages/StudentMyFilesPage';
import WriterMyFilesPage from './pages/WriterMyFilesPage';
import EditorMyFilesPage from './pages/EditorMyFilesPage';
import WriterSignInPage from './pages/WriterSignInPage';

// Separate component for routing logic
const AppRoutes = () => {
  const { user, loading } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();

  console.log('Loading User', loading);
  console.log('User found', user);

  const isWriter = () => user?.role === 'Writer';
  const isStudent = () => user?.role === 'Student';
  const isEditor = () => user?.role === 'Editor';
  const isAdmin = () => user?.role === 'Admin';

  

  // Show loading spinner only during initial auth check
  // if (loading) {
  //   return (
  //     <Box sx={{ height: '100vh', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
  //       <CircularProgress style={{ height: '18px', width: '18px', color: 'orange' }} thickness={7} />
  //     </Box>
  //   );
  // }

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={isWriter()?<Navigate to="/writer/dashboard"/>:<Home />} />
        <Route path="*" element={<NotFound />} />
        <Route path="/login" element={<SignInPage />} />
        <Route path="/moderators/login" element={<AdminEditorSignInPage />} />

        {/* Student Routes */}
        <Route path="/student/dashboard" element={isStudent() ? <StudentDashboardPage /> : <Navigate to="/" />} />
        <Route path="/student/chat" element={isStudent() ? <StudentChat /> : <Navigate to="/" />} />
        <Route path="/student/payment-history" element={isStudent() ? <StudentPaymentsPage /> : <Navigate to="/" />} />
        <Route path="/student/myorders" element={isStudent() ? <StudentMyOrdersPage /> : <Navigate to="/" />} />
        <Route path="/student/my-writers" element={isStudent() ? <MyWritersPage /> : <Navigate to="/" />} />
        <Route path="/student/post-neworder" element={isStudent() ? <PostNewOrderPage /> : <Navigate to="/" />} />
        <Route path="/student/settings" element={isStudent() ? <StudentSettingsPage /> : <Navigate to="/" />} />
        <Route path="/student/placeorder/step/1" element={<PlaceOrder />} />
        <Route path="/student/placeorder/step/2" element={<PlaceOrderStep2 />} />
        <Route path="/student/placeorder/step/3" element={<PlaceOrderStep3 />} />
        <Route path="/student/placeorder/step/4" element={<PlaceOrderStep4 />} />
        <Route path="/student/my-files" element={<StudentMyFilesPage />} />

        {/* Writer Routes */}
        <Route path="/writer/login" element={<WriterSignInPage />} />
        <Route path="/writer/dashboard" element={isWriter() ? <Dashboard /> : <Navigate to="/" />} />
        <Route path="/writer/bid-orders" element={isWriter() ? <BidOrders /> : <Navigate to="/" />} />
        <Route path="/writer/my-orders" element={isWriter() ? <WritersMyOrdersPage /> : <Navigate to="/" />} />
        <Route path="/writer/my-profile" element={isWriter() ? <WriterProfile /> : <Navigate to="/" />} />
        <Route path="/writer/payment-history" element={isWriter() ? <WriterPayments /> : <Navigate to="/" />} />
        <Route path="/writer/create-account" element={<WriterCreateAccountPage />} />
        <Route path="/writer/chat" element={isWriter() ? <WriterChat /> : <Navigate to="/" />} />
        <Route path="/writer/my-files" element={<WriterMyFilesPage />} />

        {/* Editor Routes */}
        <Route path="/editor/dashboard" element={isEditor() ? <EditorDashboardPage /> : <Navigate to="/" />} />
        <Route path="/editor/assigned-orders" element={isEditor() ? <EditorAssignedOrdersPage /> : <Navigate to="/" />} />
        <Route path="/editor/my-writers" element={isEditor() ? <EditorWritersPage /> : <Navigate to="/" />} />
        <Route path="/editor/chat" element={isEditor() ? <EditorChatPage /> : <Navigate to="/" />} />
        <Route path="/editor/my-files" element={<EditorMyFilesPage />} />

        {/* Admin Routes */}
        <Route path="/admin/all-orders" element={isAdmin() ? <AdminAllOrdersPage /> : <Navigate to="/" />} />
        <Route path="/admin/editors" element={isAdmin() ? <AdminEditorsPage /> : <Navigate to="/" />} />
        <Route path="/admin/writers" element={isAdmin() ? <AdminWritersPage /> : <Navigate to="/" />} />
        <Route path="/admin/chat" element={isAdmin() ? <AdminChatPage /> : <Navigate to="/" />} />
        <Route path="/admin/overdue-tasks" element={isAdmin() ? <OverDueTasksPage /> : <Navigate to="/" />} />
        <Route path="/admin/students" element={isAdmin() ? <StudentsPage /> : <Navigate to="/" />} />
        <Route path="/admin/dashboard" element={isAdmin() ? <AdminDashboardPage /> : <Navigate to="/" />} />
        <Route path="/admin/financial-reports" element={isAdmin() ? <FinancialReportsPage /> : <Navigate to="/" />} />
        <Route path="/admin/settings" element={isAdmin() ? <AdminSettingsPage /> : <Navigate to="/" />} />
        <Route path="/admin/writer-profile/:id" element={isAdmin() ? <WriterProfilePage /> : <Navigate to="/" />} />
        <Route path="/admin/editor-profile/:id" element={isAdmin() ? <EditorProfilePage /> : <Navigate to="/" />} />

        {/* Footer Routes */}
        <Route path="/privacypolicy" element={<PrivacyPolicy/>} />
        <Route path="/refundpolicy" element={<RefundPolicy />} />
        <Route path="/termsandconditions" element={<TermsAndPrivacy />} />
        <Route path="/cookiepolicy" element={<CookiePolicy />} />

      </Routes>
    </>
  );
};

// Main App component
function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
